// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1Rz7s","search":"Settings_search__fM0nh","filter":"Settings_filter__1n29i"};